"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RowHeaderCell_1 = require("./RowHeaderCell");
var HeaderColumn_1 = require("./HeaderColumn");
var Utils_1 = require("./Utils");
var GridSelection_1 = require("./GridSelection");
var HeaderRow = /** @class */ (function (_super) {
    __extends(HeaderRow, _super);
    function HeaderRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleReportHeaderWidth = function (columnKey, width) {
            if (_this.props.measureColumnWidths) {
                _this.measuredHeaderWidths[columnKey] = Math.max(width, _this.measuredHeaderWidths[columnKey] || 0);
            }
        };
        return _this;
    }
    HeaderRow.prototype.componentWillMount = function () {
        this.measuredHeaderWidths = {};
    };
    HeaderRow.prototype.componentDidMount = function () {
        this.reportMeasuredColumnWidths();
    };
    HeaderRow.prototype.componentDidUpdate = function () {
        this.reportMeasuredColumnWidths();
    };
    HeaderRow.prototype.reportMeasuredColumnWidths = function () {
        if (this.props.measureColumnWidths && Object.keys(this.measuredHeaderWidths).length > 0) {
            var measuredHeaderWidths = Utils_1.assign({}, this.measuredHeaderWidths);
            this.measuredHeaderWidths = {};
            this.props.measureColumnWidths(measuredHeaderWidths);
        }
    };
    HeaderRow.prototype.isColumnSelected = function (colIdx) {
        if (!this.props.selectionData) {
            return false;
        }
        // If the selectionData is IndexBasedSelectionData then test it, otherwise return false
        if (this.props.isSelectionDataIndexBased) {
            return GridSelection_1.GridSelection.isColSelected(colIdx, this.props.selectionData);
        }
        else {
            return false;
        }
    };
    HeaderRow.prototype.render = function () {
        var columnWidths = this.props.columnWidths || {};
        // tslint:disable-next-line
        var hcols = [];
        if (this.props.showRowHeaderCell && this.props.colStartIdx === 0) {
            hcols.push(RowHeaderCell_1.RowHeaderCell.element({
                key: "hcell",
                isSelected: false,
                onRowHeaderCellClick: this.props.onRowHeaderCellClick,
                rowType: RowHeaderCell_1.RowHeaderCell.RowType.Header,
                testId: 'hcell'
            }));
        }
        for (var colIdx = this.props.colStartIdx; colIdx <= this.props.colEndIdx; colIdx++) {
            var col = this.props.cols[colIdx];
            var shouldReportWidth = !col.preferredWidth && this.props.measuredColumnWidths[col.name] === undefined;
            hcols.push(HeaderColumn_1.HeaderColumn.element({
                key: col.name,
                col: col,
                colIdx: colIdx,
                isSelected: this.isColumnSelected(colIdx),
                sorted: this.props.sortKey === col.dataKey,
                sortAscending: this.props.sortAscending,
                reportWidthFn: shouldReportWidth ? this.handleReportHeaderWidth : undefined,
                width: shouldReportWidth ? undefined : columnWidths[col.name],
                minWidth: this.props.minColWidth,
                onColumnResize: this.props.onColumnResize,
                onColumnHeaderClick: this.props.onColumnHeaderClick,
                onHeaderClicked: this.props.onHeaderClicked,
                onHeaderDoubleClick: this.props.onHeaderDoubleClick,
                onHeaderContextMenu: this.props.onHeaderContextMenu
            }));
        }
        return (React.createElement("div", { className: 'tb-react-dg-hrow', style: { paddingLeft: this.props.leftMargin } },
            React.createElement("div", { className: 'tb-react-dg-hcols', style: { marginLeft: -this.props.scrollLeft } }, hcols)));
    };
    HeaderRow.displayName = 'DataGridHeaderRow';
    HeaderRow.element = React.createFactory(HeaderRow);
    return HeaderRow;
}(React.PureComponent));
exports.HeaderRow = HeaderRow;
//# sourceMappingURL=HeaderRow.js.map